<template>
  <el-select
    v-model="valueBackup"
    :placeholder="placeholder"
    filterable
    remote
    :multiple="multiple"
    :collapse-tags="multiple"
    :size="size"
    :remote-method="handleRemote"
    :loading="isLoading"
    :clearable="clearable"
    :popper-class="isFilter ? 'select-detail-popper' : ''"
    @change="handleChange"
  >
    <el-option
      v-for="v in listBackup"
      :key="v.id"
      :label="formatOptionLabel(v)"
      :value="v.id"
    >
      <!-- 筛选场景：两行展示「名称+已删除标记+实际价格 / 购买范围与次数、天数+ID」，便于区分重名类型 -->
      <v-select-option-detail
        v-if="isFilter"
        :title="v.card_ticket_type_name"
        :value="`${toYuan(v.price)} 元`"
        :meta="formatFilterMeta(v)"
        :extra="`ID ${v.id}`"
        :deleted="isDeleted(v)"
      />
      <!-- 表单场景：沿用原来的完整类型详情 -->
      <template v-else>
        <span>{{ v.card_ticket_type_name }}</span><span v-if="findCardTicketPurchaseScope(v).value">［{{ findCardTicketPurchaseScope(v).name }}］</span><span v-if="v.is_only_one">［每人限持一张］</span><span>，{{ toYuan(v.expire_number) }} 次, {{ toYuan(v.expire_days) }} 天，{{ toYuan(v.price) }} 元</span>
      </template>
    </el-option>
  </el-select>
</template>

<script>
import { index } from '@/api/card-ticket-type';
import { toYuan } from '@/filters';
import { findCardTicketPurchaseScope } from '@/enums/cardTicketPurchaseScopes';

export default {
  props: {
    value: {
      type: [Number, String, Array],
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    multiple: Boolean,
    // 列表筛选场景：下拉项两行展示「类型名+已删除标记 / 实际价格+购买范围、次数、天数+ID」，
    // 一次多加载类型（含已删除类型）；选中项仍只显示类型名，避免多选 tag 过长
    isFilter: Boolean,
    // 仅搜索/展示可在小程序展示与购买的课次券类型
    isOnlyShowApp: Boolean,
    // 必须显式声明并透传给 el-select：否则父级传的 size 不会生效，高度会退回默认 40px
    size: { type: String, default: 'medium' },
    placeholder: { type: String, default: '请输入课次券名称进行搜索' },
    clearable: { type: Boolean, default: true },
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    isLoading: false,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
        return;
      }

      if (value !== this.valueBackup) this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup || []);
        return;
      }

      if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
    },
    list(list) {
      if (JSON.stringify(list) !== JSON.stringify(this.listBackup)) this.listBackup = list || [];
    },
  },
  methods: {
    findCardTicketPurchaseScope,
    toYuan(price) {
      return toYuan(price);
    },
    // 类型是否已被删除（is_del 存删除时间戳，> 0 即已删除）
    isDeleted(v) {
      return Number(v.is_del) > 0;
    },
    // 筛选下拉的次要信息：购买范围 + 次数、天数，用于区分同名同价的类型
    formatFilterMeta(v) {
      const scope = findCardTicketPurchaseScope(v).name;
      return `${scope} · ${toYuan(v.expire_number)} 次 · ${toYuan(v.expire_days)} 天`;
    },
    // 选中项只显示类型名（多选 tag 不宜过长），已删除的类型补标记，避免选中后看不出选的是历史类型
    formatOptionLabel(v) {
      if (!this.isFilter) return v.card_ticket_type_name;
      return this.isDeleted(v) ? `${v.card_ticket_type_name}（已删除）` : v.card_ticket_type_name;
    },
    handleChange(valueBackup) {
      if (this.multiple) return this.$emit('change', valueBackup || []);
      if (!valueBackup) return [];

      for (let i = 0; i < this.listBackup.length; i++) {
        if (this.listBackup[i].id === valueBackup) return this.$emit('change', this.listBackup[i]);
      }
    },
    async getList(keyword) {
      this.isLoading = true;
      const params = { keyword, is_disable_count: 1 };
      if (this.isFilter) {
        params.size = 200;
        // 筛选场景把已删除的类型一起查出来：历史课次券仍引用这些类型，运营回顾旧券时要能按它筛选
        params.is_not_filter_del = 1;
      }
      if (this.isOnlyShowApp) params.is_show_app = 1;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (!isError) this.listBackup = data;
    },
    handleRemote(keyword) {
      if (keyword) return this.getList(keyword);

      this.list = [];
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }

    if (this.list.length) {
      return this.listBackup = this.list;
    }

    this.getList('');
  },
};
</script>

<style scoped>
/* 选中的 tag 只显示课次券名称；名称最长 20 字，超出时省略而不是溢出输入框 */
/deep/ .el-select__tags .el-tag {
  max-width: 100%;
}

/deep/ .el-select__tags .el-select__tags-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
